const ListingMap = ({
  additionalEventLevelPriceInfo,
  blendedEvent,
  blendedLogicApplied,
  currency,
  genreId,
  listing,
  listingRows,
  eventId,
  eventLevelStats,
  eventPricingSummary,
  maxQuantity,
  minQuantity,
  pricingSummary,
  rows,
  sectionStats,
  start,
  totalListings,
  totalTickets,
  zoneStats,
}) => {
  return {
    additionalEventLevelPriceInfo,
    blendedEvent,
    blendedLogicApplied,
    currency,
    eventId: Number(eventId),
    eventLevelStats,
    eventPricingSummary,
    genreId: Number(genreId),
    listing,
    listingRows,
    maxQuantity: Number(maxQuantity),
    minQuantity: Number(minQuantity),
    pricingSummary,
    rows: Number(rows),
    sectionStats,
    start: Number(start),
    totalListings: Number(totalListings),
    totalTickets: Number(totalTickets),
    zoneStats,
  };
};

export default ListingMap;
